import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEdit$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEdit extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9125f8006169c8961edf589fcb8030a346296641', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '376406ba8f1d8e1451a047632567cf3b45bb9450', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '46d0454e50d54bca06cd3c2a8737d510539be94a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.25 6.5H3.5A.5.5 0 0 1 3 6v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H6.75v9H8.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V16a.5.5 0 0 1 .5-.5h1.75zm10.14 5.82 3.47 3.47a.5.5 0 0 1-.08.8l-.35.35a.5.5 0 0 1-.71 0l-3.48-3.48-1.37 2.12a.36.36 0 0 1-.66-.08l-2-6.78a.37.37 0 0 1 .46-.46l6.81 2a.36.36 0 0 1 .09.65z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-edit", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-edit"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-edit":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEdit$1);
            }
            break;
    } });
}

const CosmosIconEdit = CosmosIconEdit$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEdit, defineCustomElement };
